import { Injectable, Injector } from "@angular/core";
import { Service } from "@services/service";

@Injectable()
export class FeatureService extends Service {
	constructor(injector: Injector) {
		super("Module", injector);
	}
}